import { IExport } from 'APIPackage/ImportExportModule/interfaces/IExport';
import { IFilterResult } from 'APIPackage/MainModule/interfaces/IFilterResult';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';
import { apiDelete, apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';
import { IDecisionListFilterRaw } from 'DecisionListPackage/MainModule/interfaces/IDecisionListFilterRaw';
import { IDecisionListFilterParams } from 'DecisionListPackage/MainModule/interfaces/IDecisionListFilterParams';

export async function fetchDecisionFilters(): Promise<IFilterResult[]> {
  return apiGet<IFilterResult[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/decision-passport`);
}

export async function fetchDecisionFilterById(id: number): Promise<IDecisionListFilterRaw> {
  return apiGet<IDecisionListFilterRaw>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/decision-passport/${id}`,
  );
}

export async function createDecisionFilter(data: IDecisionListFilterRaw): Promise<IFilterResult> {
  const knmFilter = { ...data };

  return apiPost<IFilterResult>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/decision-passport`,
    body: knmFilter,
  });
}

export async function updateDecisionFilter(id: number, data: IDecisionListFilterRaw): Promise<void> {
  return apiPut(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/decision-passport/${id}`, data);
}

export async function deleteDecisionFilter(id: number): Promise<void> {
  return apiDelete(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/${id}`);
}

export async function exportPmList(
  format: ExportFormatsEnum,
  filter: IDecisionListFilterParams | null,
  columns: ITableColumn<IKnmRaw>[],
): Promise<IExport> {
  const params = new URLSearchParams();

  params.set('format', format);

  return apiPost<IExport>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/export/decision-passport?${params}`,
    body: {
      ...filter,
      /**
       * Соответствует правилу отображения таблицы (Table.tsx): колонка выбрана,
       * если только isSelected !== false. Простая проверка на истинность отбросит
       * стандартные колонки (isSelected === undefined) при первой загрузке
       * и отправит пустой массив requiredColumns.
       */
      requiredColumns: columns.filter(col => col.isSelected !== false).map(col => col.id),
    },
  });
}
